<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-gray-900">
    <div class="text-center">
      <div class="w-16 h-16 mx-auto mb-4">
        <div class="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-brand-accent"></div>
      </div>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
        {{ title || $t('common.loading') }}
      </h2>
      <p v-if="message" class="text-gray-600 dark:text-gray-400">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  message?: string
}

defineProps<Props>()
</script>